import { ComponentChildren } from 'preact';
import styles from '../global-modal.scss';

interface ModalWrapperProps {
  children: ComponentChildren;
  onClose: (e: MouseEvent) => void;
}

export const ModalWrapper = ({ children, onClose }: ModalWrapperProps) => {
  return (
    <div class='inspired-global-modal'>
      <style>{styles}</style>
      <div class='modal-overlay'>
        <div class='modal-content' onClick={onClose}>
          {children}
        </div>
        <div class='modal-close' onClick={onClose}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
          >
            <line x1='18' y1='6' x2='6' y2='18'></line>
            <line x1='6' y1='6' x2='18' y2='18'></line>
          </svg>
        </div>
      </div>
    </div>
  );
};
